import React from 'react';

const ProgressIndicator = ({ currentStep = 1, totalSteps = 6 }) => {
  const clampedStep = Math.max(1, Math.min(currentStep, totalSteps));

  return (
    <div
      className="progress-container"
      role="progressbar"
      aria-valuenow={clampedStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Schritt ${clampedStep} von ${totalSteps}`}
    >
      <div className="progress-dots-row">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < clampedStep;
          const isCurrent = stepNumber === clampedStep;
          const isUpcoming = stepNumber > clampedStep;
          return (
            <React.Fragment key={stepNumber}>
              <div
                className={[
                  'progress-dot',
                  isCompleted ? 'progress-dot-completed' : '',
                  isCurrent ? 'progress-dot-current progress-dot-active' : '',
                  isUpcoming ? 'progress-dot-upcoming' : '',
                ]?.filter(Boolean)?.join(' ')}
                aria-hidden="true"
              />
              {index < totalSteps - 1 && (
                <div
                  className={`progress-connector ${isCompleted ? 'progress-connector-completed' : ''}`}
                  aria-hidden="true"
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;